import React, { useRef } from "react";
import { Card, Button, Breadcrumb, Affix, Form } from "antd";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../../Common/Header";
import { isMobileView } from "../../../Common/AppHelper";
import AddB2bLcForm from "./AddB2bLcForm";

export default function AddIou(props) {
  // Props
  const { width } = props;

  //   Router
  const propertyFormRef = useRef(null);
  const navigate = useNavigate();

  //   Form
  const [form] = Form.useForm();

  const discartForm = () => {
    navigate("/import/b2blc");
  };

  const addIou = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add B2B LC/RTGS/TT"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={1}
                  danger
                  onClick={() => discartForm()}
                >
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={2}
                  type="primary"
                  onClick={() => addIou()}
                >
                  Save
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <AddB2bLcForm ref={propertyFormRef} form={form} />
    </>
  );
}
